import BarChart from './BarChart.svelte';
import ScatterPlot from './ScatterPlot.svelte';
import Tomaten from './Tomaten.svelte';
import Seasonal from './Seasonal.svelte';
import fragments from '../fragments.json';

const components = {
  'barchart': BarChart,
  'scatterplot': ScatterPlot,
  'tomaten': Tomaten,
  'seasonal': Seasonal,
}

const devContainer = document.querySelector('#dev_container');
const loremContainer = document.querySelector('#dev_lorem');
const lorem = loremContainer ? loremContainer.innerHTML : '';

fragments.forEach((f) => {

  if (devContainer) {

    const c = document.createElement('div');
    c.id = f.containerId;
    if (f.class) c.classList.add('tslr-block-' + f.class);
    devContainer.appendChild(c)

    const p = document.createElement('p');
    p.innerHTML = lorem;
    devContainer.appendChild(p)

  }

  const t = document.querySelector('#' + f.containerId);
  if (t) new components[f.name]({
    target: t,
    hydrate: true,
  });

});
